import { useEffect, useState } from 'react';

// Simple and stable scroll animation system
export const useStableScrollAnimation = () => {
  const [scrollDirection, setScrollDirection] = useState('down');
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const currentScrollY = window.pageYOffset;
          const direction = currentScrollY > lastScrollY ? 'down' : 'up';
          
          // Only update direction if there's a significant change
          if (Math.abs(currentScrollY - lastScrollY) > 5) {
            setScrollDirection(direction);
            setLastScrollY(currentScrollY);
          }
          
          // Handle animations for all sections
          const sections = document.querySelectorAll('section[id]');
          
          sections.forEach((section) => {
            const rect = section.getBoundingClientRect();
            const isInView = rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
            
            if (isInView) {
              // Section is in view - animate in
              const elements = section.querySelectorAll('.progressive-element, .dynamic-content');
              elements.forEach((element, index) => {
                setTimeout(() => {
                  element.classList.add('loaded');
                  element.classList.remove('unloaded');
                }, index * 50);
              });
            } else if (direction === 'up' && rect.bottom < -100) {
              // Section is completely above viewport and scrolling up - animate out
              const elements = section.querySelectorAll('.progressive-element, .dynamic-content');
              elements.forEach((element) => {
                element.classList.remove('loaded');
                element.classList.add('unloaded');
              });
            }
          });
          
          ticking = false;
        });
        ticking = true;
      }
    };

    // Initial animation trigger
    setTimeout(() => {
      const sections = document.querySelectorAll('section[id]');
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
        
        if (isInView) {
          const elements = section.querySelectorAll('.progressive-element, .dynamic-content');
          elements.forEach((element, index) => {
            setTimeout(() => {
              element.classList.add('loaded');
            }, index * 100);
          });
        }
      });
    }, 100);

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return { scrollDirection };
};
